import axios from "axios";
import {id3, addEdges} from "../decision/id3"
import {ref} from "vue";

function format(str) {
    if (str.length > 30) {
        let next = [];
        let itms = str.split(" ");
        let curr = 0;
        for (let i = 0; i < itms.length; i++) {
            curr += itms[i].length;
            if (curr > 15) {
                curr = 0;
                next.push("\n");
            }
            next.push(itms[i]);
        }

        return next.join(' ');
    }
    return str;
}

function processNode(n) {
    let txt = n.alias.split("_")
    let links = {}
    if (n.type === "feature") {
        for (let v in n.vals) {
            let next = processNode(n.vals[v]);
            links[next.id] = next;
        }

        return {
            id: txt[1],
            val: txt[2],
            name: n.name,
            type: n.type,
            responses: links
        }
    }

    if (n.type === "feature_value") {
        let next = processNode(n.child);
        links[next.id] = next;
        return {
            id: txt[1],
            val: txt[2],
            name: n.name,
            type: n.type,
            question: links
        }
    }

    if (n.type === "result") {
        return {
            id: txt[1],
            val: txt[2],
            name: n.name,
            type: n.type,
            links: {}
        }
    }
}


async function buildTree(fillVar, isCompleteVar) {
    let qs = ref([]);
    let grd = ref({});

    let req1 = axios.get("https://nyu.danielwalt.io/api/questions")
        .then((resp)=> {
            qs.value = resp.data;
        })
        .catch((err) => {
            console.log(err);
            qs.value=[{}]
        });
    let req2 = axios.get("https://nyu.danielwalt.io/api/grid")
        .then((resp) => {
            grd.value = resp.data;
        })
        .catch((err) => {
            console.log(err);
            grd.value={};
        })

    await req1;
    await req2;

    let features = [];
    let feature_names = []

    let gridVal = grd.value;
    let qVal = qs.value;
    for (const prop in gridVal.assignments) {
        // each algorithm row
        const algoRow = gridVal.assignments[prop];
        let obs = {algoId: prop}
        for (const q in algoRow ) {
            feature_names.push(qVal[q].text);
            if (algoRow[q] === "") {
                obs[qVal[q].text] = "___"
            } else {
                obs[qVal[q].text] = algoRow[q]
            }
        }
        features.push(obs);
    }

    let fnames = [...new Set(feature_names)];
    // console.log(fnames);
    let model = id3(features, "algoId", fnames);

    let g = new Array();
    let graph = addEdges(model, g).reverse();

    let featureNodes = {};
    let answerNodes = {};
    let resultNodes = {};
    let paths = [];
    for (const edge in graph) {
        let n = graph[edge];
        if (n.type === "feature") {
            featureNodes[n.parent[1]] = n.parent[0];
            answerNodes[n.current[1]] = n.current[0];
        } else {
            answerNodes[n.parent[1]] = n.parent[0];
            if (!(n.current[1] in featureNodes)) {
                resultNodes[n.current[1]] = n.current[0];
            }
        }
        paths.push([n.parent[1], n.current[1]]);
    }

    let adjacencies = processNode(model);

    let dot = "digraph {\n" +
        "size=\"8,8\"\n" +
        "ratio=\"fill\"\n" +
        "rankdir=\"LR\"\n"

    let fStyle = "[" +
        // "shape=square," +
        "style=filled," +
        "penwidth=0," +
        "fillcolor=forestgreen," +
        "fontcolor=white," +
        "fontsize=\"24pt\"" +
        "fontname=\"IBM Plex Sans\","

    let aStyle =  "[" +
        // "shape=diamond," +
        "style=filled," +
        "penwidth=0," +
        "fillcolor=cornflowerblue," +
        "fontcolor=white," +
        "fontsize=\"24pt\"" +
        "fontname=\"IBM Plex Sans\","

    let rStyle =  "[" +
        "fixedsize=true," +
        "width=2,height=2," +
        "shape=tripleoctagon," +
        "style=filled," +
        "penwidth=0," +
        "fillcolor=crimson," +
        "fontcolor=white," +
        "fontsize=\"32pt\"" +
        "fontname=\"IBM Plex Sans\","

    for (const _n in featureNodes) {
        dot += "\"" + _n + "\" " + fStyle + "label=\"" + format(featureNodes[_n]) + "\"]\n";
    }

    for (const _n in answerNodes) {
        if (_n in featureNodes) {
            continue;
        }
        dot += "\"" + _n + "\" " + aStyle + "label=\"" + format(answerNodes[_n]) + "\"]\n";
    }

    for (const _n in resultNodes) {
        let node_id = parseInt(resultNodes[_n]) + 1;
        dot += "\"" + _n + "\" " + rStyle + "label=\"" + node_id + "\", URL=\"/prng/algo/" + node_id +"\"]\n";
    }

    for (const edge in paths) {
        dot += "\"" + paths[edge][0] + "\" -> \"" + paths[edge][1] + "\";\n";
    }

    dot += "}";

    // console.log(dot);

    fillVar.value = {model: model, edges: graph, dot: dot, adj: adjacencies};

    isCompleteVar(true);
    return fillVar
}

export {buildTree}